(function() {

  $(document).ready(function() {
    $('.owl-carousel').owlCarousel({
      autoplay: true,
      autoplayTimeout: 7000,
      autoplayHoverPause: true,
      dots: false,
      items: 1,
      nav: true,
      navElement: 'div class="material-icons"',
      navText: ['chevron_left', 'chevron_right']
    });
  });

  $('.ps-nav__toggle').click(function() {
    $('.ps-nav').toggleClass('is-visible');
  });

})();
